export default {"src":"/_next/static/media/badge.7648849e.svg","height":79,"width":72,"blurWidth":0,"blurHeight":0};